import Vue from 'vue'
import SubNavApp from './SubNavApp.vue'

document.addEventListener('DOMContentLoaded', () => {
    const id = 'left-sub-nav'
    const ele = document.getElementById(id)
    if (ele) {
        const nav = JSON.parse(ele.dataset.nav as string)
        new Vue({
            name: 'SubNavApp',
            render: (h) =>
                h(SubNavApp, {
                    props: {
                        nav,
                    },
                }),
        }).$mount('#' + id)
    }
})
